{
  "header": {
    "title": "Fragenbibliothek",
    "description": "Verwalten Sie Ihre Feedbackkategorien und Fragen",
    "addCategoryButton": "Kategorie hinzufügen"
  },
  "searchInput": {
    "placeholder": "Fragen suchen"
  },
  "delete": {
    "title": "Kategorie löschen",
    "description": "Möchten Sie diese Kategorie wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden und alle zugehörigen Fragen und Antworten werden dauerhaft entfernt.",
    "deleteButton": "Kategorie löschen",
    "cancelButton": "Abbrechen"
  },
  "translationOverview": {
    "title": "Übersetzung in andere Sprachen",
    "description": "Wir verwenden KI-Übersetzungen, daher kann das Ergebnis Fehler enthalten"
  },
  "detailsPage": {
    "header": {
      "backButton": "Zurück zu den Fragenkategorien",
      "questionsCount": "{{questionsCount}} Fragen",
      "addQuestionButton": "Frage hinzufügen"
    },
    "searchInput": {
      "placeholder": "Fragen suchen"
    },
    "sortDropdown": {
      "triggerLabel": "Sortieren nach",
      "options": {
        "questionQuantity": "Fragenanzahl",
        "fromNewestToOldest": "Von neuestem zu ältestem",
        "fromOldestToNewest": "Von ältestem zu neuestem"
      }
    },
    "delete": {
      "title": "Frage löschen",
      "description": "Möchten Sie diese Frage wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden und alle zugehörigen Antworten werden dauerhaft entfernt.",
      "deleteButton": "Frage löschen",
      "cancelButton": "Abbrechen"
    },
    "translationOverview": {
      "title": "Übersetzung in andere Sprachen",
      "description": "Wir verwenden KI-Übersetzungen, daher kann das Ergebnis Fehler enthalten"
    }
  }
}
